//-- delay function for resizing
var delay = (function() {
    var timer = 0;
    return function(callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    }
})();

const sliderNav = (sliderObj) => {

    var slider = sliderObj,
        item_length = slider.find('> div').length - 1,
        sliderParent = slider.parents('.slider-wrapper'),
        sliderNav = sliderParent.find('.slider-nav');

        sliderNav.addClass('first-slide').find('.nav-btn--left').addClass('edge')

    slider.on('afterChange', function(event, slick, currentSlide){

        sliderNav.removeClass('first-slide last-slide').find('.nav-btn').removeClass('edge')
        if( currentSlide == 0 ){
            sliderNav.addClass('first-slide').find('.nav-btn--left').addClass('edge')
        };
        if( currentSlide == item_length ){
            sliderNav.addClass('last-slide').find('.nav-btn--right').addClass('edge')
        };
    });
}

const detectEdge = (sliderObj) => {
    var slider = sliderObj,
        currentSlide = $(slider).find('.slick-current').attr("data-slick-index"),
        item_length = slider.find('> div').length - 1;

    if( currentSlide == 0 || currentSlide == item_length ){

        return true

    } else {

        return false

    }
}

const sliderHome = () => {

    var sliderPrev = $('#slider-home-solutions-left'),
        sliderNext = $('#slider-home-solutions-right');

    var  slider = $(".slider-home-solutions").slick({

        infinite: false,
        infinite: false,
        arrows: false,
        variableWidth: true,
        asNavFor: '.slider-phone',

        responsive: [{

        }]
    });

    function launchAnimation() {
        var currentSlide = $('.slider-home-solutions .slick-current').attr("data-slick-index");

        $('.slider-phone').find('video').each(function(index){
            this.pause();
            this.currentTime = 0;

            if(index == currentSlide) {
                this.play();
            }
        })
    }

    sliderPrev.click(function(){


        slider.slick('slickPrev');

        //console.log(detectEdge(slider))

        //if (!isEdge) {
            //launchAnimation()
            
        //}

        launchAnimation()

    });

    sliderNext.click(function(){

        slider.slick('slickNext');

        //console.log(detectEdge(slider))

        //if (!isEdge) {
            //launchAnimation()
            
        //}

        launchAnimation()

    });
}

const sliderPhone = () => {

    var slider = $(".slider-phone")

    sliderNav(slider)

    slider.slick({

        infinite: false,
        infinite: false,
        arrows: false,
        asNavFor: '.slider-home-solutions',

        responsive: [{


        }]
    });
}

const aboutSlider1 = () => {

    var sliderPrev = $('#about-slider-content-left'),
        sliderNext = $('#about-slider-content-right');

    var slider = $(".about-slider-content");

    sliderNav(slider)

    slider.slick({
        speed: 600,
        infinite: false,
        arrows: false,
        asNavFor: '.about-slider-images',
        responsive: [{

        }]
    });

    var width = $(window).width();

    sliderPrev.click(function(){

        if (width >= 1200) {
            $('.about-slider-images').find('.slick-slide').removeClass('slick-animate')
            $('.about-slider-images').find('.slick-current').not(':first-child').addClass('slick-animate')

            delay(function () {
                slider.slick('slickPrev');
            }, 800);
        } else {
            slider.slick('slickPrev');
        }

    });

    sliderNext.click(function(){

        if (width >= 1200) {
            $('.about-slider-images').find('.slick-slide').removeClass('slick-animate')
            $('.about-slider-images').find('.slick-current').not(':last-child').addClass('slick-animate')

            delay(function () {
                slider.slick('slickNext');
            },800)
        } else {
            slider.slick('slickNext');
        }

    });
}

const aboutSlider2 = () => {

    var width = $(window).width(),
        swipe;

    if (width >= 1200) {
        swipe = false
    } else {
        swipe = true
    };

    var slider = $(".about-slider-images").slick({

        speed: 600,
        infinite: false,
        arrows: false,
        fade: false,
        swipe: swipe,
        asNavFor: '.about-slider-content',

        responsive: [{

        }]
    });

}

const continuousSlider = () => {

    var slideWidth,
        speed,
        width = $(window).width();

    if (width < 768) {
        slideWidth = 100;
        speed = 12000;
    } else {
        slideWidth = 250;
        speed = 20000;
    }

    if ($('.continuous-slider').length > 0) {

        $('.continuous-slider').bxSlider({
            mode: 'horizontal',
            moveSlides: 1,
            slideMargin: 40,
            infiniteLoop: true,
            slideWidth: slideWidth,
            minSlides: 3,
            maxSlides: 5,
            speed: speed,
            ticker: true
        });

    }

}

module.exports = {

    sliderHome, 
    sliderPhone, 
    aboutSlider1,
    aboutSlider2,
    sliderNav,
    continuousSlider

};